module.exports = __webpack_public_path__ + "static/media/22.6bd59198.png";